export const clubsRouteNames = {
  IndoorGolf: 'clubs/indoor-golf',
  ClubSingle: 'clubs/club-single'
}
